import { useParams } from "react-router-dom";
import { ServiceProxy } from "@me-team/host/main/graphql/types";
import { DeleteServiceMutation, useDeleteServiceMutation } from "@me-team/host/main/services/graphql/services.hooks";
import { ApolloError } from "@apollo/client";

interface ServiceHookProps {
    service?: Pick<ServiceProxy, "id"> | null;
    onCompleted: (data?: DeleteServiceMutation) => void;
    onError: (error: ApolloError) => void;
}
export const useService = ({
    service,
    onCompleted,
    onError,
}: ServiceHookProps): {
    handleDelete: () => Promise<void>;
} => {
    const { branchId } = useParams();
    const [deleteService] = useDeleteServiceMutation();

    const handleDelete = async () => {
        if (!service) return;

        await deleteService({
            variables: { serviceId: service.id, branchId: +branchId },
            context: {
                errorType: "global",
            },
            onCompleted: onCompleted,
            onError: onError,
        });
    };

    return {
        handleDelete,
    };
};
